module.exports = __webpack_public_path__ + "static/media/person-bob-harper.84bd3483.png";